export default __webpack_public_path__ + "static/media/Rect2.6447a1f6.svg";